module.exports = __webpack_public_path__ + "img/rectangle-table-6.1167a85f.png";